<template>
  <v-container class="pa-4">
    <v-row>
      <v-col
        cols="12"
        md="12"
        sm="12"
      >
        <h2>Webアカウント登録</h2>
      </v-col>
    </v-row>
    <template v-if="$route.params.subscription_id">
    <v-row>
      <v-col>
        <v-data-table
          :headers="subscription_headers"
          :items="selectedSubscription"
          hide-default-footer
        >
        </v-data-table>
        <template v-slot:item.web_accounts="{ item }">
            <span v-if="item.webaccount_max_count">{{ item.webaccount_count }}/{{ item.webaccount_max_count }}</span>
        </template>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    </template>
    <v-row>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="email"
          v-model="item.email"
          :error-messages="validation_errors.email"
        >
        </v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="ユーザー名"
          v-model="item.username"
          :error-messages="validation_errors.username"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-switch
          label="管理者"
          v-model="item.is_admin"
          :error-messages="validation_errors.is_admin"
        ></v-switch>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-switch
          label="退会済み"
          v-model="item.is_deleted"
          readonly
          :error-messages="validation_errors.is_deleted"
        ></v-switch>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="最終更新者"
          v-model="item.updated_by"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="4"
        sm="8"
      >
        <v-text-field
          label="最終更新日"
          v-model="item.updated_at"
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="3"><v-btn class="red white--text" @click="save">保存する</v-btn></v-col>
      <template v-if="!$attrs.isCreate && item.is_active">
      <v-col cols="12" sm="3"><v-btn class="red white--text" @click="password_reset">パスワード再発行</v-btn></v-col>
      </template>
      <template v-if="!$attrs.isCreate && !item.is_active">
      <v-col cols="12" sm="3"><v-btn class="red white--text" @click="password_reset">パスワード初回発行</v-btn></v-col>
      </template>
    </v-row>
    <v-row v-if="!$attrs.isCreate && new_password">
      <v-col><span>発行されたパスワード「{{ new_password }}」を担当者にお知らせください</span></v-col>
    </v-row>
    <template v-if="!$attrs.isCreate">
      <v-row>
        <v-col>
          <v-divider></v-divider>
          <v-subheader>このアカウントの購読情報</v-subheader>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <subscription-search @select="addSubscription($event)"></subscription-search>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-data-table
            hide-default-footer
            :headers="webaccountsubscription_headers"
            :items="subscriptions"
            :items-per-page="50"
            :footer-props="footer_props"
            disable-sort
            disable-filtering
            locale="ja-jp"
            loading-text="読込中"
            no-data-text="データがありません。"
          >
          <template v-slot:item.web_accounts="{ item }">
              <span v-if="item.subscription.webaccount_max_count">{{ item.subscription.webaccount_count }}/{{ item.subscription.webaccount_max_count }}</span>
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              small
              color="default"
              class="title-btn red white--text"
              @click="deleteSubscription(item)"
            >
             解除する 
            </v-btn>
          </template>
          </v-data-table>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import SubscriptionSearch from '@/components/SubscriptionSearch'

export default {
  components: {
    'subscription-search': SubscriptionSearch,
  },
  data() {
    return {
      title: '',
      new_password: null,
      item: {},
      validation_errors: {},
      subscription_headers: [
        {text: "顧客コード", value: "client.cd"},
        {text: "顧客名称", value: "client.name_combined"},
        {text: "電話番号", value: "client.tel"},
        {text: "商品", value: "productdetail.name"},
        {text: "部数", value: "sum_amount"},
        {text: "ステータス", value: "status.name"},
        {text: `WEBアカウント`, value: "web_accounts"},
      ],
      webaccountsubscription_headers: [
        {text: "顧客コード", value: "subscription.client.cd"},
        {text: "顧客名称", value: "subscription.client.name_combined"},
        {text: "商品", value: "subscription.productdetail.name"},
        {text: "部数", value: "subscription.sum_amount"},
        {text: "ステータス", value: "subscription.status.name"},
        {text: `WEBアカウント`, value: "web_accounts"},
        {text: `操作`, value: "action"},
      ],
      selectedSubscription: [],
      subscriptions: [],
      footer_props: {
        'items-per-page-options': [],
        'items-per-page-text': null,
        'disable-items-per-page': true,
      },
      dialog: false,
    }
  },
  created() {
    if (this.$attrs.isCreate) {
      this.title = "Webアカウント登録"
    } else {
      this.title = "Webアカウント編集"
      this.getItem();
      this.getSubscriptions();
    }
    if (this.$route.params.subscription_id) {
      this.getSelectedSubscription();
    }
  },
  methods: {
    async getSelectedSubscription() {
      const subscription_id = this.$route.params.subscription_id;
      if (!subscription_id) {
        return;
      }
      try {
        let response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/subscriptions/${subscription_id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.selectedSubscription = [response.data]
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
      }
    },
    async getSubscriptions() {
      try {
        let response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/accounts/${this.$route.params.id}/subscriptions/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.subscriptions = response.data
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
      }
    },
    async getItem() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/accounts/${this.$route.params.id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        const data = response.data;
        this.item = data;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
      }
    },
    async save() {
      if (this.$attrs.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    async create() {
      try {
        const response = await this.$axios.post(
          `${process.env.VUE_APP_API_URL_BASE}/api/accounts/`,
          this.item,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        const item_id = response.data.id;
        let to = {'name': 'EditWebAccount', 'params': {id: item_id}};
        if (this.$route.params.subscription_id) {
          await this.$axios.post(
            `${process.env.VUE_APP_API_URL_BASE}/api/accounts/${item_id}/subscriptions/`,
            {subscription_id: this.$route.params.subscription_id},
            {
              headers: {
                Authorization: `JWT ${this.$store.getters.token}`,
              },
            },
          );
          to = {'name': 'WebAccountListSubscription', 'params': {subscription_id: this.$route.params.subscription_id}};
        }
        this.validation_errors = {};
        this.$store.dispatch('setSnackbar', {message: "登録されました", type: "success"});
        this.$router.push(to);
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "登録できませんでした", type: "error"});
        this.validation_errors = error.response.data;
      }
    },
    async update() {
      try {
        await this.$axios.put(
          `${process.env.VUE_APP_API_URL_BASE}/api/accounts/${this.$route.params.id}/`,
          this.item,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.validation_errors = {};
        this.$store.dispatch('setSnackbar', {message: "保存されました", type: "success"});
        await this.getItem();
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "更新できませんでした", type: "error"});
        this.validation_errors = error.resopnse.data;
      }
    },
    async addSubscription(item) {
      try {
        await this.$axios.post(
          `${process.env.VUE_APP_API_URL_BASE}/api/accounts/${this.$route.params.id}/subscriptions/`,
          {subscription_id: item.id},
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.getSubscriptions();
        this.$store.dispatch('setSnackbar', {message: "購読情報が追加されました", type: "success"});
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "更新できませんでした", type: "error"});
      }
    },
    async deleteSubscription(item) {
      console.log(item);
      try {
        await this.$axios.delete(
          `${process.env.VUE_APP_API_URL_BASE}/api/accounts/${this.$route.params.id}/subscriptions/`,
          {data: {subscription_id: item.subscription.id}},
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.getSubscriptions();
        this.$store.dispatch('setSnackbar', {message: "購読情報が追加されました", type: "success"});
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "更新できませんでした", type: "error"});
      }
    },
    async password_reset() {
      try {
        const response = await this.$axios.post(
          `${process.env.VUE_APP_API_URL_BASE}/api/accounts/${this.$route.params.id}/password_reset/`,
          {},
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.new_password = response.data.password;
        this.$store.dispatch('setSnackbar', {message: "パスワードがリセットされました", type: "success"});
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "パスワードリセットに失敗しました", type: "error"});
      }
    }
  }
}
</script>